'use strict';
module.exports = require('./Calendar.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/calendar/index.js
// module id = 82
// module chunks = 1